<template>
  <b-container class="container-project">
    <div class="p-5 bg-dark text-white text-center" v-if="!showPayment">
      <div class="display-4 text-customer my-4">¡Atención!</div>
      <div class="lead">
        <i>Próximamente podrás realizar aquí todos tus pagos.</i>
      </div>
    </div>

    <div
      class="container-payments"
      v-else-if="payment_data.payments.length > 0"
    >
      <h2 class="text-center text-bold mt-4">
        Contrato Nº
        {{
          new Intl.NumberFormat("es-CL").format(payment_data.contract_number)
        }}
      </h2>
      <br />
      <div v-if="forpayMandate" class="text-center mt-4 mb-3 alert alert-info">
        Ya posees un mandato de Forpay activo asociado a este contrato, puedes
        ver el detalle en la pestaña de <b>PAGOS AUTOMÁTICOS</b>
      </div>
      <div v-else class="text-center mt-4 mb-3 alert alert-info">
        Configura Forpay en este contrato para facilitar los pagos de tus cuotas
        en la pestaña de <b>PAGOS AUTOMÁTICOS</b>
      </div>
      <b-overlay :show="transbank.loading" rounded="lg" spinner-variant="gold">
        <b-row style="width: 100%" class="content-card">
          <b-col class="px-0">
            <b-table-simple condensed borderless hover>
              <tbody>
                <b-tr
                  class="d-none d-lg-table-row text-white text-center"
                  style="background-color: #707070"
                >
                  <b-th>Descripción</b-th>
                  <b-th>Monto Pactado</b-th>
                  <b-th>Fecha Pactada</b-th>
                  <b-th>Tipo Pago</b-th>
                  <b-th>Estado</b-th>
                  <b-th>Acción</b-th>
                </b-tr>
                <template v-for="(payment, key) in pageOfItems">
                  <b-tr
                    v-if="payment_valid(payment)"
                    :key="'pay-tr' + key"
                    class="d-none d-lg-table-row payment-table"
                  >
                    <b-td>
                      {{ payment.descripcionPago }}
                    </b-td>
                    <b-td>
                      {{
                        new Intl.NumberFormat("es-CL").format(payment.montoPago)
                      }}
                      UF
                    </b-td>
                    <b-td>
                      {{
                        (gcVersion == 1
                          ? payment.fechaVencimientoPago
                          : payment.fechaVencimientoPago
                              .toString()
                              .slice(0, 10)) | moment("DD-MM-YYYY")
                      }}
                    </b-td>
                    <b-td>
                      <div>-</div>
                    </b-td>
                    <b-td>
                      <h5>
                        <b-badge v-if="is_payed(payment)" variant="pagado">{{
                          text_payed(payment)
                        }}</b-badge>
                        <b-badge
                          v-else-if="active_toku(payment)"
                          variant="sin-pagar"
                          >Programado</b-badge
                        >
                        <b-badge
                          v-else-if="
                            parseFloat(payment.montoPago) > 0 &&
                            payment.fechaVencimientoPago < date_today &&
                            ![
                              'Crédito Hipotecario',
                              'Pie Crédito Directo',
                              'Pie Promesa',
                            ].includes(payment.descripcionPago)
                          "
                          variant="danger"
                          >Atrasado</b-badge
                        >
                        <b-badge v-else variant="sin-pagar">Sin Pagar</b-badge>
                      </h5>
                    </b-td>
                    <b-td>
                      <b-button
                        block
                        v-if="is_payed(payment)"
                        pill
                        variant="secondary"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        target="_blank"
                        :disabled="
                          text_payed(payment) == 'Documentado' ? true : false
                        "
                        >Recibo</b-button
                      >
                      <b-button
                        block
                        v-else-if="false"
                        pill
                        @click="showModal(payment)"
                        variant="customer"
                        class="my-2 my-sm-0"
                        type="button"
                        :disabled="true"
                        >-</b-button
                      >
                      <b-button
                        block
                        v-else
                        pill
                        @click="showModalToku(payment)"
                        variant="customer"
                        class="my-2 my-sm-0"
                        type="button"
                        :disabled="true"
                        >-</b-button
                      >
                    </b-td>
                  </b-tr>
                  <b-tr :key="'small-pay-tr' + key" class="d-lg-none">
                    <b-td>
                      <b>{{ payment.descripcionPago }}</b> <br />
                      {{
                        new Intl.NumberFormat("es-CL").format(payment.montoPago)
                      }}
                      UF <br />
                      <small>
                        {{
                          (gcVersion == 1
                            ? payment.fechaVencimientoPago
                            : payment.fechaVencimientoPago
                                .toString()
                                .slice(0, 10)) | moment("DD-MM-YYYY")
                        }}</small
                      >
                      <h5>
                        <b-badge v-if="is_payed(payment)" variant="success"
                          >Pagado</b-badge
                        >
                        <b-badge
                          v-else-if="
                            parseFloat(payment.montoPago) > 0 &&
                            payment.fechaVencimientoPago < date_today &&
                            ![
                              'Crédito Hipotecario',
                              'Pie Crédito Directo',
                              'Pie Promesa',
                            ].includes(payment.descripcionPago)
                          "
                          variant="danger"
                          >Atrasado</b-badge
                        >
                        <b-badge v-else variant="secondary">Sin Pagar</b-badge>
                      </h5>
                    </b-td>
                    <b-td class="align-middle text-right">
                      <b-button
                        block
                        v-if="is_payed(payment)"
                        pill
                        variant="secondary"
                        class="my-2 my-sm-0"
                        type="button"
                        :href="payment.urlReport"
                        target="_blank"
                        >Recibo</b-button
                      >
                      <b-button
                        block
                        v-else
                        pill
                        @click="showModalToku(payment)"
                        variant="customer"
                        class="my-2 my-sm-0"
                        type="button"
                        :disabled="payment.montoPago == 0 ? true : false"
                        >Pagar</b-button
                      >
                    </b-td>
                  </b-tr>
                </template>
              </tbody>
            </b-table-simple>
          </b-col>
        </b-row>
        <div class="text-right">
          <jw-pagination
            :pageSize="10"
            :items="payment_data.payments"
            @changePage="onChangePage"
            :styles="customStyles"
            :labels="customLabels"
          ></jw-pagination>
        </div>
        <b-modal ref="modal-add-toku" hide-footer title="Pagar vía Toku">
          <b-overlay :show="false" rounded="lg" spinner-variant="gold">
            <div class="d-block text-center">
              <h3>
                <small>Monto: </small>$
                {{ new Intl.NumberFormat("es-CL").format(transbank.monto) }}
              </h3>
            </div>
            <b-button
              @click="add_forpay(payment_data.contract_number)"
              block
              squared
              variant="outline-success"
              class="my-2 my-sm-0"
              type="button"
              target="_blank"
              >Agregar Mandato</b-button
            >
          </b-overlay>
        </b-modal>
      </b-overlay>
    </div>
  </b-container>
</template>
<script>
export default {
  name: "paymentsToku",
  components: {},
  props: {
    project_id: null,
    asset_id: null,
  },
  data() {
    return {
      showPayment: true,
      customStyles: {
        li: {
          display: "inline-block",
        },
        a: {
          color: "black",
        },
      },
      customLabels: {
        first: "<<",
        last: ">>",
        previous: "<",
        next: ">",
      },
      transbank: {
        token: "",
        url: "",
        monto: "",
        concept: "",
        back_url: window.location.href,
        id: "",
        loading: false,
      },
      pageOfItems: [],
      Apartment: null,
      loading: true,
      selected_payment: null,
      payment_data: {
        contract_number: "",
        payments: [],
        loading: null,
      },
    };
  },
  mounted() {
    this.apartment = this.$store.getters.getApartmentById(
      parseInt(this.asset_id)
    );
    this.loadPayments();
  },
  computed: {
    have_tokus() {
      if (this.$store.getters.getTokus != undefined) {
        let filter = this.$store.getters.getTokus.filter(
          (toku) => toku.contract_id == this.payment_data.contract_number
        );
        return filter.length > 0;
      } else {
        return false;
      }
    },
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : 0;
    },
    date_today() {
      return this.$moment(new Date()).format("YYYY-MM-DD");
    },
    gcVersion() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.gc_version
        : 1;
    },
    forpayMandate() {
      return this.$store.getters.getForpayMandate;
    },
  },
  methods: {
    payment_valid(payment) {
      let customer = [68, 102, 103, 129];
      let payments_banned = [
        "cuota de ajuste",
        "crédito hipotecario",
        "subsidio",
        "comision broker",
        "bono pie",
        "gift card",
        "bono galco",
        "contado contra escritura",
        "aporte inmobiliario",
        "aporte inmobiliaria",
      ];
      if (customer.includes(this.customerId)) {
        return payments_banned.includes(payment.descripcionPago) ? false : true;
      } else {
        return true;
      }
    },
    loadPayments() {
      var self = this;
      this.axios.get("payments/").then((result) => {
        result.data.map(function (value) {
          self.loading = false;
          value.bienes.map(function (v) {
            if (self.asset_id == v.id) {
              self.payment_data.contract_number = value.id;
              self.Apartment = v;
              self.payment_data.payments = value.pagos;
              self.payment_data.loading = false;
              self.$store.commit("setContractId", value.id);
            }
          });
        });
      });
    },
    add_forpay(contract_id) {
      this.transbank.loading = true;
      this.axios
        .post("payments/forpay", {
          contract_id: contract_id,
        })
        .then((result) => {
          let url_redirect = result.data.url;
          if (url_redirect == "") {
            this.$swal(
              "Oops",
              "hubo un error agregando tu pago, favor intentar más tarde if redirect",
              "error"
            );
            this.transbank.loading = false;
          } else {
            window.location.href = url_redirect;
          }
        })
        .catch(() => {
          this.$swal(
            "Oops",
            "hubo un error agregando tu pago, favor intentar más tarde 500",
            "error"
          );
          this.transbank.loading = false;
        });
    },
    text_payed(payment) {
      if (payment.reciboPago.length > 0) {
        return ["CANCELADO", "DEPOSITADO"].includes(
          payment.reciboPago[0].estadoPago
        )
          ? "Pagado"
          : payment.reciboPago[0].estadoPago;
      }
    },
    active_toku(payment) {
      if (
        this.$store.getters.getTokus.length > 0 &&
        payment.descripcionPago == "Pie Contra Promesa"
      ) {
        return this.have_tokus;
      } else {
        return false;
      }
    },
    onChangePage(pageOfItems) {
      this.pageOfItems = pageOfItems;
    },
    showModal(payment) {
      this.$refs["my-modal"].show();
      this.transbank.id = payment.codigo;
      this.transbank.monto = Math.round(payment.montoPago * payment.valorUF);
    },
    showModalToku(payment) {
      this.selected_payment = payment;
      this.$refs["modal-add-toku"].show();
      this.transbank.monto = Math.round(payment.montoPago * payment.valorUF);
    },
    is_payed(payment) {
      if (payment.reciboPago === undefined) {
        return false;
      } else {
        return payment.reciboPago.length > 0 ? true : false;
      }
    },
  },
};
</script>
<style></style>
